import {
  FAILED_GET_SPORT,
  FAILED_GET_SPORTS,
  RECEIVE_GET_SPORT,
  RECEIVE_GET_SPORT_EVENT_TEMPLATES,
  RECEIVE_GET_SPORTS,
} from 'redux/actions/sport'
import {RESET_STATE} from 'redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0
  },
  templates: {
    data: [],
    error: '',
    fetching: true,
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_SPORT:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        }
      }
    case RECEIVE_GET_SPORT:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        }
      }
    case RECEIVE_GET_SPORT_EVENT_TEMPLATES:
      return {
        ...state,
        templates: {
          data: action.data,
          fetching: false,
          sending: false,
        }
      }
    case RECEIVE_GET_SPORTS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
        }
      }
    case RESET_STATE:
      if (action.state === 'sport') {
        return {
          ...state,
          [action.screen]: initialState[action.screen]
        }
      }
    default:
      return state
  }
}
